module.exports = __webpack_public_path__ + "img/025.9e5d2efe.jpg";